import { render, staticRenderFns } from "./EditDynamicRoute.vue?vue&type=template&id=4deac2d6&"
import script from "./EditDynamicRoute.vue?vue&type=script&lang=js&"
export * from "./EditDynamicRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports